import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  CONFIRM_BOOKING_V2,
  DOWNLOAD_BOOKING_V2,
  DOWNLOAD_BOOKING_V2_EMPTY,
  GET_BOOKING_LIST_V2,
  GET_BOOKING_LIST_V2_EMPTY,
} from '../../../../../../store/actions';
import { ActionConfirmation, BreadCrumb, Loader } from '../../../../../Common';
import { Container } from 'reactstrap';
import Filter from './Components/Filters/Filter';
import Table from './Components/Tables/Table';
import { Constant } from '../../../../../Helpers/constant';

const StaticCouponV2 = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [isShowConfirmationModal, setIsShowConfirmationModal] = useState(false);
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState(null);
  const [bookingType, setBookingType] = useState(['STATIC_COUPON']);
  const [loading, setLoading] = useState(false);

  /* ---------------------------- REDUX STATES ---------------------------- */
  // Bookings
  const { bookings, bookingsLoading, bookingsError } = useSelector((state: any) => ({
    bookings: state?.BookingsV2?.data,
    bookingsLoading: state?.BookingsV2?.loading,
    bookingsError: state?.BookingsV2?.error,
  }));

  // Click Download Dump
  const { downloadDump, downloadDumpLoading } = useSelector((state: any) => ({
    downloadDump: state?.DownloadDumpV2?.data,
    downloadDumpLoading: state?.DownloadDumpV2?.loading,
  }));

  /* ---------------------------- DISPATCHING ---------------------------- */
  useEffect(() => {
    return () => {
      dispatch({
        type: GET_BOOKING_LIST_V2_EMPTY,
      });
    };
  }, [dispatch]);

  useEffect(() => {
    if (downloadDump !== null) {
      dispatch({
        type: DOWNLOAD_BOOKING_V2_EMPTY,
      });
    }
  }, [downloadDump]);

  useEffect(() => {
    dispatch({
      type: GET_BOOKING_LIST_V2,
      payload: {
        data: {
          booking_type: bookingType,
          page: currentPageNumber,
          sort_by: 'updated_at',
          page_size: Constant.TABLE_PAGE_SIZE,
          sort_direction: 'DESC',
        },
      },
    });
  }, [dispatch]);

  /* ---------------------------- BREADCRUMB HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    } else if (title === `Delayed Coupon Booking`) {
      // do nothing
    }
  };

  /* ---------------------------- FILTER SUBMIT HANDLER ---------------------------- */
  const filterSubmitHandler = filters => {
    if (filters?.filter) {
      setCurrentPageNumber(1);
      setCurrentlyAppliedFilters(filters);

      dispatch({
        type: GET_BOOKING_LIST_V2,
        payload: {
          data: {
            booking_type: bookingType,
            page: 1,
            page_size: Constant.TABLE_PAGE_SIZE,
            sort_direction: 'DESC',
            ...filters,
          },
        },
      });
    } else {
      setCurrentlyAppliedFilters(filters);
    }
  };

  /* ---------------------------- FILTER RESET HANDLER ---------------------------- */
  const onResetHandler = () => {
    setCurrentPageNumber(1);

    dispatch({
      type: GET_BOOKING_LIST_V2,
      payload: {
        data: {
          booking_type: bookingType,
          page: 1,
          sort_direction: 'DESC',
          page_size: Constant.TABLE_PAGE_SIZE,
        },
      },
    });
  };

  /* ---------------------------- PAGINATION HANDLER ---------------------------- */
  const paginationHandler = pageNumber => {
    setCurrentPageNumber(pageNumber + 1);

    dispatch({
      type: GET_BOOKING_LIST_V2,
      payload: {
        data: {
          booking_type: bookingType,
          page: pageNumber + 1,
          page_size: Constant.TABLE_PAGE_SIZE,
          sort_by: currentlyAppliedFilters?.sort_by ?? 'updated_at',
          sort_direction: 'DESC',
          ...currentlyAppliedFilters,
        },
      },
    });
  };

  /* ---------------------------- TABLE ACTION HANDLER ---------------------------- */
  const tableActionHandler = params => {
    if (params?.actionType === `CONFIRM`) {
      setIsShowConfirmationModal(true);
    } else if (params?.actionType === `CANCEL`) {
      setIsShowConfirmationModal(true);
    }
  };

  /* ---------------------------- DOWNLOAD DUMP HANDLER ---------------------------- */
  const downloadDumpHandler = () => {
    dispatch({
      type: DOWNLOAD_BOOKING_V2,
      payload: {
        data: {
          booking_type: bookingType,
          ...currentlyAppliedFilters,
        },
      },
    });
  };

  useEffect(() => {
    if (bookingsLoading || downloadDumpLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [bookingsLoading, downloadDumpLoading]);

  return (
    <>
      {loading && <Loader />}

      <div className="page-content">
        <Container fluid className="position-relative">
          {/*  ----------------------------  UI'S ---------------------------- */}

          <>
            <BreadCrumb title="Static Coupon Booking" navigationby={breadcrumNavigationHandler} navigation={[`Dashboard`, `Static Coupon Booking`]} />
            <Filter data={{}} filterHandler={filterSubmitHandler} appliedFilters={currentlyAppliedFilters} onReset={onResetHandler} />

            <Table
              data={bookings?.result}
              totalData={bookings?.total_count}
              pageNumber={currentPageNumber}
              pageHandler={paginationHandler}
              actionHandler={tableActionHandler}
              appliedFilters={currentlyAppliedFilters}
              dumpDownload={downloadDumpHandler}
            />
          </>
        </Container>
      </div>
    </>
  );
};

export default StaticCouponV2;
